export default String.raw`
<div class="customer-submenu">
	<div class="customer-submenu__header">
		{{ translations.Complaints }}/{{ translations.Returns }}
	</div>
	<div data-template="partials/customer-profile/complaints/complaints.html">
		{% capture link -%}<a href="{{ page.BaseHref }}{{config.DefinedPages.CustomerProfile.Url}}?tab=orders" rel="nofollow">{{ translations.OrderListGenitive }}</a>{% endcapture -%}
		<div class="message-container">{{ translations.ComplaintInfo | Format:link }}</div>
		<div class="change-container">
		{% if page.QueryString contains 'tab=executed-complaints' -%}
			{% assign executedComplaints = true -%}
		{% else -%}
			{% assign executedComplaints = false -%}
		{% endif -%}
			<div class="change-container__type">
				<button class="change-type-js change-orders-source-js parent-container-reload-js change-container__type text {% if executedComplaints == false -%} active {% endif -%}" data-url="{{ page.Url }}?tab=active-complaints">{{ translations.UnderExecution }}</button>
			</div>
			<div class="change-container__type">
				<button class="change-type-js change-orders-source-js parent-container-reload-js change-container__type text {% if executedComplaints -%} active {% endif -%}" data-url="{{ page.Url }}?tab=executed-complaints">{{ translations.Executed }}</button>
			</div>
			<div class="slider"></div>
		</div>
		<div class="complaints-js container-js" data-template="partials/common/complaint-details.html">
		{% include 'partials/customer-profile/complaints/complaints-list.html' -%}
		</div>
	</div>
</div>
`